import { useState, useEffect } from "react"
import qrCode from "qrcode"

import Style from "./style"

import useGetEventDetail from "entity/event/useGetEventDetail"

import { convertEventTypeAsName } from "shared/constant/lookup/eventType"
import timestampCalculator from "shared/lib/timestampCalculator"

const EventQr = () => {
    const [qrUrl, setQrUrl] = useState("")

    const [eventData] = useGetEventDetail()
    const uuid = eventData?.data?.uuid

    useEffect(() => {
        if (uuid) qrCode.toDataURL(uuid).then(setQrUrl)
    }, [uuid])

    return (
        <Style.Wrapper>
            <h1>[{convertEventTypeAsName[eventData?.data?.event_type_flag]}] {eventData?.data?.name}</h1>
            <h2>{timestampCalculator(eventData?.data?.date)}</h2>
            <p>QR 코드</p>
            <img src={qrUrl} />
            <h2>위 대회의 참가 기록이 없으면, QR 인식을 통해 참가를 할 수 있습니다.</h2>
            <h2>만약 참가 기록이 있다면, QR 인식을 통해 탈락 처리가 진행됩니다.</h2>
        </Style.Wrapper>
    )
}

export default EventQr